import {LabelsListSearchComponent} from './LabelsListSearchComponent'
import { DLMLabelSetsQueryResponseProvider, DLMTypesQueryResponseProvider } from '../../../../core/doclabel'
const LabelsListHeader = () => {

    return (
    <div className='card-header border-0 pt-6 d-flex flex-column mb-8'>
        <h1>Serial Label Directory</h1>
        <DLMLabelSetsQueryResponseProvider>
        <DLMTypesQueryResponseProvider>
            <LabelsListSearchComponent />
        </DLMTypesQueryResponseProvider>
        </DLMLabelSetsQueryResponseProvider>
    </div>
    )
}

export {LabelsListHeader}
